import React from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';

import { CenteredText } from '../styles/CenteredText';

function SectionPresentation() {
  return (
    <Section>
      <Block
        blockWidth="100%"
        textAlign="center"
        alignItems="center"
      >
        <CenteredText
          variant="title"
          gutterBottom={2}
          intlKey="CAREERS.PRESENTATION.TITLE"
        />
        <CenteredText
          variant="paragraph2"
          gutterBottom={2}
          intlKey="CAREERS.PRESENTATION.DESCRIPTION"
          intlValues={{ br: <br /> }}
        />

        <FormattedMessage id="CAREERS.GREENHOUSE_LINK">
          {([greenhouseLink]) => (
            <Link
              href={greenhouseLink}
              variant="action"
              color="primary"
              intlKey="CAREERS.PRESENTATION.POSITIONS_BUTTON"
            />
          )}
        </FormattedMessage>
      </Block>
    </Section>
  );
}

export default React.memo(SectionPresentation);
